// @ts-expect-error ts-migrate(7016) FIXME: Try `npm install @types/wix__wix-fullstory-loader`... Remove this comment to see the full error message
import wixFullstoryLoader from '@wix/wix-fullstory-loader';

export function initFullstory() {
  wixFullstoryLoader({
    label: 'marketing-template-viewer',
  });
}
